import { Box, Divider, IconButton, Tooltip, Typography } from '@mui/material';
import SearchBox from '../../../../../../../search-box/SearchBox';
import React, { useContext } from 'react';
import {
    MessageQuestionCustomLinearIcon,
    ProfileCircleBulkIcon
} from '../../../../../../../icons-lib';
import i18n from '../../../../../../../i18';
import { ShopBulkIcon } from '../../../../../../../icons-lib/bulkIcons';
import { AppDataContext } from '../../../../../../../context/Context';

export const ServerSelectField = ({
    field,
    data,
    // additionalData,
    onChange,
    wrapperRef
}) => {
    const icons = {
        merchantLocations: <ShopBulkIcon />,
        default: <ProfileCircleBulkIcon />
    };
    const context = useContext(AppDataContext);
    const server = context.getState().server[field.serverController];
    const {
        id,
        label,
        tipText,
        needDivider,
        searchFields,
        serverController,
        associatedSettings = {},
        saveFullData
    } = field;
    const {
        primary,
        secondary,
        multiple,
        primaryType,
        secondaryType,
        primaryLabel,
        hideSecondaryLabel
    } = associatedSettings;
    const translatedLabel = i18n.t(`columns.${label}`);
    const addLabel = i18n.t(`buttons.${label}Add`);
    const primaryLabelKey = primaryLabel || primary;
    const primaryTitle = primary ? i18n.t(`columns.${primaryLabelKey}`) : '';
    const secondaryTitle = secondary ? i18n.t(`columns.${secondary}`) : '';
    const translatedSearchLabel = i18n.t(`pages.${serverController}.title`);

    const [items, setItems] = React.useState([]);
    const [totalCount, setTotalCount] = React.useState(0);

    React.useEffect(() => {
        try {
            const fetchData = async () => {
                const response = await server.search(5);
                setTotalCount(response.total_count);
                setItems(response.data);
            };
            fetchData();
        } catch (error) {
            console.error('Error fetching items', error);
        }
    }, [server, serverController]);

    const icon = icons[label] || icons.default;

    const getValue = (value) => {
        if (multiple) return value?.map((v) => v.id) || [];
        return value?.id || null;
    };
    const value = saveFullData ? getValue(data) : data;

    return (
        <Box sx={{ mb: 2 }}>
            <Box display={'flex'} alignItems={'center'}>
                <Typography variant="h5">{translatedLabel}</Typography>
                {tipText && (
                    <Tooltip title={i18n.t(`text.${tipText}`)} placement="top">
                        <IconButton size="small">
                            <MessageQuestionCustomLinearIcon
                                sx={{ fontSize: '1rem' }}
                            />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            {items && items.length > 0 && (
                <SearchBox
                    serverSearch={true}
                    searchFields={searchFields}
                    searchController={serverController}
                    handleChange={(val) => onChange(id, val)}
                    icon={icon}
                    translatedLabel={translatedLabel}
                    multiple={multiple}
                    value={value}
                    primaryTitle={primaryTitle}
                    secondaryTitle={secondaryTitle}
                    primaryKey={primary}
                    secondaryKey={secondary}
                    primaryType={primaryType}
                    secondaryType={secondaryType}
                    hideSecondaryLabel={hideSecondaryLabel}
                    items={items}
                    // wrapperRef={wrapperRef}
                    addAssociationLabel={addLabel}
                    translatedSearchLabel={translatedSearchLabel}
                    totalItemsCount={totalCount}
                    saveFullData={saveFullData}
                />
            )}
            {needDivider && <Divider sx={{ marginY: 2 }} />}
        </Box>
    );
};
